// Client-side overlap detection for the Schedule board conflict badges.
const parse = (s) => (s ? new Date(String(s).replace("Z", "")) : null);

const overlaps = (s1, e1, s2, e2) => {
  if (!s1 || !s2) return false;
  const a1 = s1, b1 = e1 || s1, a2 = s2, b2 = e2 || s2;
  return a1 < b2 && a2 < b1;
};

// Returns a Set of requisition ids that double-book a driver or truck.
export function computeConflicts(reqs) {
  const active = reqs.filter((r) => !["Completed", "Cancelled"].includes(r.status));
  const ids = new Set();
  for (let i = 0; i < active.length; i++) {
    for (let j = i + 1; j < active.length; j++) {
      const a = active[i], b = active[j];
      const as = parse(a.estimated_start), ae = parse(a.estimated_end);
      const bs = parse(b.estimated_start), be = parse(b.estimated_end);
      if (!overlaps(as, ae, bs, be)) continue;
      const sameDriver = a.driver_name && a.driver_name === b.driver_name;
      const sameTruck = a.truck_unit_number && String(a.truck_unit_number) === String(b.truck_unit_number);
      if (sameDriver || sameTruck) { ids.add(a.id); ids.add(b.id); }
    }
  }
  return ids;
}
